import { useSearchParams } from "react-router-dom";
import CustomerStore from "@/components/Store/CustomerStore";

const StorePreviewPage = () => {
  const [searchParams] = useSearchParams();

  // Get store data from URL parameters or use defaults
  const storeData = {
    name: searchParams.get("name") || "Sample Kente Store",
    description:
      searchParams.get("description") ||
      "Authentic Kente designs crafted with love",
    logo: searchParams.get("logo") || "",
    primaryColor: searchParams.get("primaryColor") || "#8B4513",
    secondaryColor: searchParams.get("secondaryColor") || "#DAA520",
    accentColor: searchParams.get("accentColor") || "#FFD700",
    items: [], // You can add items from URL params if needed
    isPublished: true,
    storeUrl: window.location.href,
    contactInfo: {
      email: searchParams.get("email") || "info@kentestore.com",
      phone: searchParams.get("phone") || "+233 24 123 4567",
      location: searchParams.get("location") || "Accra, Ghana",
      businessHours: {
        weekdays: searchParams.get("weekdays") || "9:00 AM - 6:00 PM",
        saturday: searchParams.get("saturday") || "10:00 AM - 4:00 PM",
        sunday: searchParams.get("sunday") || "Closed",
      },
    },
  };

  const storeSlug = searchParams.get("slug") || "sample-store";

  return (
    <div className="min-h-screen">
      <CustomerStore storeData={storeData} storeSlug={storeSlug} />
    </div>
  );
};

export default StorePreviewPage;
